import { render, staticRenderFns } from "./DeliverySection.vue?vue&type=template&id=0cc76e6e&scoped=true&"
import script from "./DeliverySection.vue?vue&type=script&lang=js&"
export * from "./DeliverySection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc76e6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cc76e6e')) {
      api.createRecord('0cc76e6e', component.options)
    } else {
      api.reload('0cc76e6e', component.options)
    }
    module.hot.accept("./DeliverySection.vue?vue&type=template&id=0cc76e6e&scoped=true&", function () {
      api.rerender('0cc76e6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sale/delivery-dashboard/components/DeliverySection.vue"
export default component.exports